import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions } from 'api';
import { getApplicationToCloseAvailableColumns, getSources } from './api';

export const path = '/close/:contactPhone';
export const getPath = (contactPhone: string) => `/close/${contactPhone}`;

const PageCloseApplications: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      positions: getPositions,
      sources: getSources,
      columns: getApplicationToCloseAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageCloseApplications;
